import React, { useMemo, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { Layout } from "./components/Layout";
import { withAnalytics } from "react-analytics-collector";
import { AppContent, ThemeModeContext } from "./contexts";
import { routes } from "./config";
import { Route as AppRoute } from "./types";
import { getAppTheme } from "./styles/theme";
import { DARK_MODE_THEME, LIGHT_MODE_THEME } from "./utils/constants";

const defaultParams = {
  timezone: [],
  updateTimezone: (t) => t,
};

export const useAppContext = () => React.useContext(AppContent);

const setLocalTimezone = (tz) => {
  window.localStorage.setItem(
    "subscriber-store",
    JSON.stringify({
      tz,
      updatedDate: Date.now(),
    })
  );
};
function App() {
  const [timezone, setTimezone] = useState();
  const [filteredComponentsList, setFilteredComponentsList] = useState([]);
  const setTimezoneStore = async (tz) => {
    setTimezone(tz);
    setLocalTimezone("UTC");
  };

  const initialValue = useMemo(
    () => ({
      timezone,
      setTimezone,
      setTimezoneStore,
      filteredComponentsList,
      setFilteredComponentsList,
    }),
    [timezone, setTimezone, filteredComponentsList]
  );
  const [mode, setMode] = useState<
    typeof LIGHT_MODE_THEME | typeof DARK_MODE_THEME
  >(LIGHT_MODE_THEME);

  const themeMode = useMemo(
    () => ({
      toggleThemeMode: () => {
        setMode((prevMode) =>
          prevMode === LIGHT_MODE_THEME ? DARK_MODE_THEME : LIGHT_MODE_THEME
        );
      },
    }),
    []
  );

  const theme = useMemo(() => getAppTheme(mode), [mode]);

  const addRoute = (route: AppRoute) => (
    <Route
      key={route.key}
      path={route.path}
      render={(props) => withAnalytics(route.path, route.component, props)}
      exact
    />
  );

  return (
    <AppContent.Provider value={initialValue}>
      <ThemeModeContext.Provider value={themeMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Switch>
              <Layout>
                {routes.map((route: AppRoute) =>
                  route.subRoutes
                    ? route.subRoutes.map((item: AppRoute) => addRoute(item))
                    : addRoute(route)
                )}
              </Layout>
            </Switch>
          </Router>
        </ThemeProvider>
      </ThemeModeContext.Provider>
    </AppContent.Provider>
  );
}

export default App;
